import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Mail } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { COMPANY } from "@/data/content";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) nav("/admin");
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Connexion impossible");
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full pl-11 pr-4 py-3 rounded-xl border border-slate-200 focus:border-[#0ea5e9] focus:ring-2 focus:ring-sky-100 outline-none transition text-sm";

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6" data-testid="login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center bg-white border border-slate-100 shadow-sm rounded-2xl px-6 py-4">
            <img src={COMPANY.logo} alt="Equinoxe Propreté" className="h-12 w-auto" />
          </div>
          <h1 className="mt-6 text-2xl font-bold text-slate-900">Espace administrateur</h1>
          <p className="mt-1 text-sm text-slate-500">Connectez-vous pour gérer devis et messages.</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.06)] p-8 space-y-5">
          {error && <div data-testid="login-error" className="bg-red-50 text-red-600 text-sm px-4 py-3 rounded-lg">{error}</div>}
          <div className="relative">
            <Mail size={17} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
            <input data-testid="login-email" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} />
          </div>
          <div className="relative">
            <Lock size={17} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
            <input data-testid="login-password" type="password" required placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} />
          </div>
          <button data-testid="login-submit" disabled={loading} className="w-full bg-[#0ea5e9] hover:bg-[#0284c7] disabled:opacity-60 text-white px-6 py-3 rounded-full font-bold transition-colors">
            {loading ? "Connexion..." : "Se connecter"}
          </button>
        </form>
        <p className="text-center mt-6 text-sm text-slate-400">
          <a href="/" className="hover:text-[#0ea5e9]">← Retour au site</a>
        </p>
      </div>
    </div>
  );
}
